import { Controller } from "@hotwired/stimulus"

// Gantt chart controller — bar hover tooltips, today scroll.

export default class extends Controller {
  static targets = ["chart", "bar", "todayLine"]

  connect() {
    this.scrollToToday()
    this.setupTooltips()
  }

  // ── Today Scroll ─────────────────────────────────────────

  scrollToToday() {
    if (!this.hasTodayLineTarget) return
    const chart = this.hasChartTarget ? this.chartTarget : this.element.querySelector(".gantt-timeline")
    if (!chart) return

    const todayLine = this.todayLineTarget
    const lineLeft = todayLine.offsetLeft
    const chartWidth = chart.offsetWidth

    // Scroll so today is roughly 1/3 from the left
    chart.scrollLeft = Math.max(0, lineLeft - chartWidth / 3)
  }

  // ── Tooltips ─────────────────────────────────────────────

  setupTooltips() {
    this.barTargets.forEach(bar => {
      bar.addEventListener("mouseenter", this.showTooltip.bind(this))
      bar.addEventListener("mouseleave", this.hideTooltip.bind(this))
    })
  }

  showTooltip(event) {
    const bar = event.currentTarget
    const title = bar.dataset.taskTitle || ""
    const start = bar.dataset.startDate || ""
    const end = bar.dataset.endDate || ""
    const column = bar.dataset.columnName || ""

    let tooltip = document.getElementById("gantt-tooltip")
    if (!tooltip) {
      tooltip = document.createElement("div")
      tooltip.id = "gantt-tooltip"
      tooltip.className = "gantt-tooltip"
      document.body.appendChild(tooltip)
    }

    const formatDate = (d) => {
      if (!d) return "—"
      return new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })
    }

    tooltip.innerHTML = `
      <div class="gantt-tooltip-title">${title}</div>
      <div class="gantt-tooltip-detail">${column}</div>
      <div class="gantt-tooltip-dates">${formatDate(start)} → ${formatDate(end)}</div>
    `

    const rect = bar.getBoundingClientRect()
    tooltip.style.top = `${rect.top + window.scrollY - tooltip.offsetHeight - 8}px`
    tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2}px`
    tooltip.classList.add("gantt-tooltip--visible")
  }

  hideTooltip() {
    const tooltip = document.getElementById("gantt-tooltip")
    tooltip?.classList.remove("gantt-tooltip--visible")
  }
}
